import {
	doc,
	query,
	getDocs,
	orderBy,
	increment,
	onSnapshot,
	collection,
	updateDoc,
} from "firebase/firestore";
import { database } from "../config";

const getAllData = async (collectionName) => {
	const returnData = [];
	await getDocs(collection(database, collectionName)).then((querySnapshot) => {
		const newData = querySnapshot.docs.map((doc) => ({
			...doc.data(),
			id: doc.id,
		}));

		returnData.push(...newData);
	});

	return returnData;
};

const incrementViewCount = async (postId) => {
	const viewedKey = `viewed_post_${postId}`;
	if (!localStorage.getItem(viewedKey)) {
		const postRef = doc(database, "posts", postId);
		await updateDoc(postRef, {
			views: increment(1),
		});
		localStorage.setItem(viewedKey, "true");
	}
};

const listenToCollection = (collectionName, callback) => {
	const unsubscribe = onSnapshot(
		collection(database, collectionName),
		(querySnapshot) => {
			const data = querySnapshot.docs.map((doc) => ({
				...doc.data(),
				id: doc.id,
			}));
			callback(data); // send real-time data to your handler
		},
		(error) => {
			console.error("Error listening to snapshot: ", error);
		}
	);

	return unsubscribe; // call this to stop listening
};

const getDataByClientAndDeliverable = async (
	collectionName,
	clientId,
	deliverable
) => {
	const subcollectionRef = collection(
		database,
		collectionName,
		clientId,
		deliverable
	);
	const q = query(subcollectionRef, orderBy("timestamp", "asc")); // or "desc"
	const querySnapshot = await getDocs(q);

	const results = querySnapshot.docs.map((doc) => ({
		id: doc.id,
		...doc.data(),
	}));

	return results;
};

const updateUserValueField = async (
	collectionName,
	documentId,
	fieldName,
	newValue,
	setShouldRefetch
) => {
	try {
		const docRef = database.collection(collectionName).doc(documentId);

		// Update the specified field in the document
		await docRef.update({
			[fieldName]: newValue,
		});
		setShouldRefetch(true);

		console.log(`${fieldName} Field updated successfully!`);
	} catch (error) {
		console.error(`Error updating ${fieldName} field:`, error);
	}
};

export {
	getAllData,
	getDataByClientAndDeliverable,
	updateUserValueField,
	listenToCollection,
	incrementViewCount,
};
